"use client";

// Fehlerzustand: ein Satz, ein Knopf. Die technische Meldung bleibt
// auf dem Server (Next ersetzt sie im Produktionsbau ohnehin).

import { useEffect } from "react";
import { AlertTriangle } from "lucide-react";
import { Button, EmptyState } from "@/components/ui";

export default function DokumenteFehler({ error, retry }: { error: unknown; retry: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  const digest = error instanceof Error ? (error as Error & { digest?: string }).digest : undefined;

  return (
    <EmptyState
      icon={AlertTriangle}
      title="Die Dokumente ließen sich nicht laden"
      description={
        digest
          ? `Fehlerkennung ${digest} — bitte bei der Ansichtssache melden, wenn es bleibt. Deine Dateien sind davon nicht betroffen.`
          : "Bitte noch einmal versuchen. Deine Dateien sind davon nicht betroffen."
      }
      action={<Button onClick={() => retry()}>Noch einmal</Button>}
    />
  );
}
